import { render, staticRenderFns } from "./UnitPriceDisplay.vue?vue&type=template&id=475712a0"
import script from "./UnitPriceDisplay.vue?vue&type=script&lang=js"
export * from "./UnitPriceDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports